import React, { Component } from "react";
import { checkTranslation, translate } from "../../utils/useful";
import FormViewer from "../FormViewer";
import SidebarView from "../SidebarView";
import StagesManager from "../StagesManager";
import DiagramSidebar from "./diagram/DiagramSidebar";
import { v4 as uuidv4 } from 'uuid';
import { diagramComponents, diagramGroups } from "../../variables/diagramFunctions";
import DiagramComponentConfig from "./diagram/DiagramComponentConfig";



class AddRuleView extends Component {
    state = {

        components: {},
        // paths: {},
        nodes: {},

        // components: [1, 1, 1, 1],
        headers: [

            // { key: 'Available', type: 'NumberInput', col: '12', information: { label: '{{lang}}Available number', placeholder: '{{lang}}Write down the number of availablity', required: false } },
            { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}Sales Price', required: true } },
            { key: 'active', type: 'SwitchInput', col: '6', information: { label: '{{lang}}Active', placeholder: '{{lang}}Active', required: false } },
        ],

        // parts: [
        //     { label: 'Rules', key: 'rules', icon: '/assets/icons/useful/action.png' },
        //     { label: 'Inuse', key: 'inuse', icon: '/assets/icons/useful/list-text.png' },
        //     { label: 'Variables', key: 'variables', icon: '/assets/icons/useful/text.svg' },
        // ],
    }

    openAddComponent = (item) => {


        this.diagramSidebar.open()
    }

    openComponentConfig = () => {


        this.diagramComponentConfig.open()
    }





    componentClicked = (item, applet) => {
        // console.log(item)

        // let components = this.state.components
        // let id = uuidv4()
        let type = item.key
        this.openMore(type, applet)
        // if (diagramComponents[type]) {
        //     let nodes = diagramComponents[type].defaultNodes ?? {}
        //     let title = diagramComponents[type].title
        //     let UI = diagramComponents[type].UI
        //     let group = diagramComponents[type].group

        //     components[id] = { key: id, type, group, positionX: null, positionY: null, nodes, title, UI } // TODO DEFAULT NODES - Title
        //     this.setState({ components }, () => {

        //         this.props.scrollTo('bottom')

        //         this.diagramComponentConfig.open()
        //         // this.container.scrollTo(0, this.container.scrollHeight)
        //         // this.container.scrollTo(100)
        //         // console.log(this.container)
        //     })
        // }
    }
    setData = (key, value, reference, cb) => {
        if (reference == 'AddRuleView') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }

    saveConfig = (data) => {
        if (!this.state.currentComponent) {
            let key = this.state.currentDiagramComponent?.key
            this.addComponent(key, data)
        } else {

            let components = this.state.components
            let key = this.state.currentComponent.key

            components[key].config = data
            this.diagramComponentConfig.close()
            this.setState({ components })
        }
    }



    addComponent = (key, config) => {

        let components = this.state.components
        let id = uuidv4()
        let type = key

        // let config = config

        if (diagramComponents[type] && config) {
            let nodes = diagramComponents[type].defaultNodes ?? {}
            let title = diagramComponents[type].title
            let UI = diagramComponents[type].UI
            let group = diagramComponents[type].group
            let applet = this.state.currentApplet?._id


            components[id] = { key: id, type, group, positionX: null, positionY: null, nodes, title, UI, config: config, applet } // TODO DEFAULT NODES - Title
            this.setState({ components }, () => {

                this.props.scrollTo('bottom')

                this.diagramSidebar.sidebarView.close()
                this.diagramSidebar.subSidebarView.close()
                this.diagramComponentConfig.close()

                // this.diagramComponentConfig.open()
                // this.container.scrollTo(0, this.container.scrollHeight)
                // this.container.scrollTo(100)
                // console.log(this.container)
            })
        }

    }


    openMore = (key, applet) => {
        let component = this.state.components[key]
        let diagramComponent = diagramComponents[component ? component.type : key]
        this.setState({ currentApplet: applet, currentComponent: component, currentDiagramComponent: diagramComponent }, () => {

            this.openComponentConfig()
            // if (isDoubleClick) {
            //     this.openConfig()
            // } else {
            //     this.moreModal.showModal()
            // }

        })


    }



    render() {
        return (
            <div className=" " ref={el => this.container = el} style={{ backgroundColor: '#f6f6f6', minHeight: this.props.height }}>
                <div className="py-2 mb-3 flexcb" style={{
                    position: 'sticky', top: 0,
                    backgroundColor: '#fff', borderBottom: 'solid 1px rgba(216, 216, 216, 0.2)'
                }} >
                    <p className="text-bold text-semibig px-3">{translate('Add Rule')}</p>

                    <p className="text-small px-3 cursor-pointer" style={{ color: '#007aff' }}>{translate('Save')}</p>
                </div>

                {/* <FormViewer ref={el => this.form = el} headers={this.state.headers} theme={"modern"} inputClass={"modern-input"} /> */}

                <div className="px-3 pb-5">
                    <div>
                        {/* <div className="mb-4">
                            <p className="text-small">Rule Details</p>
                        </div> */}

                        {/* <div className="flexc">
                            <div className="br-8" style={{ background: 'rgb(235,235,240)', }}>
                                <p className="text-smaller px-2 py-1 color-gray-2 text-semibold">Start</p>
                            </div>
                        </div> */}


                        <div className="px-2 d-flex flex-column">

                            {Object.values(this.state.components)?.length == 0 && (
                                <div className="flexcc pt-4 flex-column">
                                    <button onClick={() => this.openAddComponent()} className="bg-white px-3 py-3 br-4">
                                        <p className="text-semibold text-small" style={{ color: '#007aff' }}>{translate('+ Add a trigger for the rule')}</p>
                                    </button>

                                    <p className="text-smaller color-gray-2 mt-3" style={{ maxWidth: 400 }}>{translate('Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima exercitationem magni fuga natus beatae ducimus porro excepturi quidem nobis.')}</p>
                                </div>
                            )}

                            {Object.values(this.state.components).map((prop, index) => {
                                // console.log(prop)
                                return (
                                    <div className="flexc">
                                        <div className="d-flex flex-column ">

                                            <div className="d-flex cursor-pointer bg-white br-8" style={{ boxShadow: '0px 0px 10px #10101010', minWidth: 200 }} onClick={() => this.openMore(prop?.key)}>

                                                {/* <div className="br-8" style={{ flex: 1, padding: '0px 1px', alignSelf: 'stretch', width: 5, background: 'rgb(235,235,240)' }}>

                                        </div>
                                        <div className="flex-1 flexcc">
                                            <div className="" style={{ height: 2, padding: '0px 1px', width: 10, background: 'rgb(235,235,240)' }}>

                                            </div>
                                        </div> */}

                                                <div className="w-100 mx-2 d-flex pb-2 pt-2">

                                                    <img src={diagramComponents[prop.type]?.icon} height={30} />
                                                    <div className="px-2" style={{ maxWidth: 180 }}>
                                                        <p className="text-small text-bold">{checkTranslation(prop.config?.label)}</p>
                                                        <p className="text-smaller color-gray-2">{checkTranslation(prop.title)}</p>
                                                        <p className="text-smaller color-gray-2">{checkTranslation(prop.config?.description)}</p>

                                                    </div>
                                                </div>

                                            </div>


                                            <div className="" style={{ margin: '0px 10px', alignSelf: 'stretch', width: 5, height: 30, background: '#fff', boxShadow: '0px 0px 10px #10101010' }}>

                                            </div>

                                        </div>
                                    </div>

                                    // <div className="d-flex cursor-pointer" onClick={() => this.openAddComponent(prop)}>

                                    //     <div className="br-8" style={{ flex: 1, padding: '0px 1px', alignSelf: 'stretch', width: 5, background: 'rgb(235,235,240)' }}>

                                    //     </div>
                                    //     <div className="flex-1 flexcc">
                                    //         <div className="" style={{ height: 2, padding: '0px 1px', width: 10, background: 'rgb(235,235,240)' }}>

                                    //         </div>
                                    //     </div>

                                    //     <div className="w-100 mx-2 d-flex pb-2 pt-2">

                                    //         <img src="https://cdn-icons-png.flaticon.com/512/1828/1828163.png" height={30} />
                                    //         <div className="px-2" style={{ maxWidth: 180 }}>
                                    //             <p className="text-small text-bold">Title of the rule</p>
                                    //             <p className="text-smaller color-gray-2">Description and details of the rule will be shown here</p>

                                    //         </div>
                                    //     </div>

                                    // </div>
                                )
                            })}





                        </div>

                        {Object.values(this.state.components)?.length != 0 && (
                            <div className="mx-2 flexcc br-50 cursor-pointer" onClick={() => this.openAddComponent()} style={{ padding: '0px 1px', alignSelf: 'stretch', width: 26, height: 26, background: '#fff', boxShadow: '0px 0px 10px #10101010' }}>
                                <p className="color-gray-1">+</p>
                            </div>
                        )}




                    </div>








                </div>



                <DiagramSidebar ref={el => this.diagramSidebar = el} width={this.props.width} onDragStart={this.onDragStart} onClick={this.componentClicked} onDrop={this.onDrop} onTouchMove={this.onTouchMove} sideOpen={false} hideOverlay={false} />

                <DiagramComponentConfig ref={el => this.diagramComponentConfig = el} variables={this.props.variables} currentComponent={this.state.currentComponent} saveConfig={this.saveConfig} width={this.props.width} currentDiagramComponent={this.state.currentDiagramComponent} headers={this.state.currentDiagramComponent?.headers} initData={this.state.currentHeadersData} errors={this.state.errors} liveChange={this.formLiveChange} />


            </div>
        );
    }
}

export default AddRuleView;